<template>
  <mds-section border-position="bottom" bold>
    <template #mds-section-title>
      <span id="title-id">{{ filterInfo.title }}</span>
    </template>
    <template #mds-section-actions>
      <mds-button-container right-aligned>
        <mds-button
          v-for="element in filterInfo.actionButtons"
          :key="element.id"
          :variation="element.variation"
          type="button"
          @click="$emit('buttonclick', element.method)"
          >{{ element.text }}</mds-button
        >
      </mds-button-container>
    </template>
    <engagement-layout :leftBar="leftABar" :rightBar="rightABar">
      <template #left-side-bar>
        <div :class="$style['cf-left-advance']">
          <adl-expandable-menu
            :sections="sections"
            :menus="menus"
            :subMenus="subMenus"
            @onClick="onClickMenu"
            class="cf-left-advance"
          ></adl-expandable-menu>
        </div>
      </template>
      <template #right-side-bar>
        <slot name="dynamic-content"></slot>
      </template>
    </engagement-layout>
  </mds-section>
</template>
<script>
import MdsSection from "@mds/section";
import { MdsButton, MdsButtonContainer } from "@mds/button";
import { EngagementLayout } from "../../component";
import AdlExpandableMenu from "../custom/expandable-menu/ExpandableMenu.vue";

export default {
  data() {
    return {
      tableSetting: this.tableViewSettings,
      showTable: this.showTableView,
    };
  },
  props: {
    tableViewSettings: {
      type: Object,
    },
    showTableView: {
      type: Boolean,
      default: false,
    },
    sections: {
      type: Array,
    },
    menus: { type: Array },
    subMenus: { type: Array },
    filterInfo: { type: Object },
    filterOptions: {
      type: Array,
    },
    leftBar: {
      type: Number,
    },
    rightBar: {
      type: Number,
    },
  },
  components: {
    MdsSection,
    MdsButton,
    MdsButtonContainer,
    EngagementLayout,
    AdlExpandableMenu,
  },

  computed: {
    leftABar() {
      if (this.leftBar > 0) {
        return this.leftBar;
      } else {
        return 2;
      }
    },
    rightABar() {
      if (this.rightBar > 0) {
        return this.rightBar;
      } else {
        return 10;
      }
    },
  },

  async created() {},
  methods: {
    selectedFilter(data) {
      this.$emit("onFilterSelected", data);
    },
    onClickMenu(sectionId, menuId, submenuId) {
      this.$emit("onClick", sectionId, menuId, submenuId);
    },
  },
};
</script>
<style lang="scss" module>
.cf-left-advance {
  height: calc(90vh - 114px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 4px;
  padding-bottom: 16px;
}
.cf-left-advance::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.cf-left-advance::-webkit-scrollbar-thumb {
  background-color: #c3d0da;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}
</style>
